// enci.counter.js
// TODO: refactor busted this page, so back to the original version

import $ from 'jquery';
import 'jquery-countto';
import { debugLog } from './enci.log.js';

/**
 * Initiates a counting animation on elements with the '.count-number' class.
 * Utilizes the 'countTo' plugin to animate the numerical counters, allowing customization of the refresh interval for the animation.
 *
 * @function initSetCounterInterval
 * @param {string} selector - The CSS selector for the elements to apply the counting animation to.
 */
export function initSetCounterInterval(selector) {
  debugLog('initSetCounterInterval');

  const $countNumbers = $(selector);

  if (!$countNumbers.length) {
    debugLog(`initSetCounterInterval >> No count numbers found for ${selector}.`, {
      type: 'error',
    });
    return;
  }

  $countNumbers.countTo({
    refreshInterval: 2,
  });
}
